module.exports = __webpack_public_path__ + "static/img/cuit.9a6d0e6e.png";